import { render, staticRenderFns } from "./AboutCompanySection.vue?vue&type=template&id=7e5e7418&"
import script from "./AboutCompanySection.vue?vue&type=script&lang=js&"
export * from "./AboutCompanySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports